module.exports = __webpack_public_path__ + "img/statistic.6bd89585.png";